export function getPage(){
	if(!params) return 'default'
	const dict = {
		'pages/home.php': 'home',
		'pages/advantages.php': 'advantages',
		'pages/dinamic.php': 'dinamic',
		'pages/plan.php': 'plan',
		'pages/policy.php': 'policy',
		'pages/documents.php': 'documents',
	}
	const {page_template} = params
	return dict[page_template] || 'default'
}